import React, {useState, useEffect} from 'react';
import axios from '../Common/axios';
import {Button, Input, Modal, Select, Table, DatePicker, Typography} from "antd";
import CodeSelect from '../Common/CodeSelect';
import {getGridTableHeight, getPopupSizeOption} from '../Common/util';
import {getFindAnalysisList} from '../Common/api';
import {excelDownload} from '../Common/function';
import TemplateCreate from './TemplateCreate';
import TemplateInfo from './TemplateInfo';
import TopMenu from '../Common/TopMenu';
import {getCodeName} from '../Common/CodeSelect';
import { getCodeList } from '../Common/codeManager';

const {Option} = Select;
const { RangePicker } = DatePicker;

/** -------------------------------------------------------------------------- **/
function TemplateList() {

    // 변수 선언
    const [companyCode, setCompanyCode] = useState('TMPL');
    const [assetType, setAssetType] = useState('');
    const [assetTypeName, setAssetTypeName] = useState('');
    const [reportName, setReportName] = useState('');

    const [dataSource, setDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const [isDataChange, setIsDataChange] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [isOpenInfo, setIsOpenInfo] = useState(false);
    const [isReportId, setIsReportId] = useState(false);
    
    // 페이지 진입 시 코드 목록 갱신
    useEffect(() => {
        // 캐시된 코드 목록 갱신 (1분 캐시)
        getCodeList();
    }, []);
    
    // 자산유형 변경 시 자동 조회
    useEffect(() => {
        // 회사코드가 있을 때만 조회
        if (companyCode) {
            findTemplateList();
        }
    }, [assetType]);
    
    // 회사코드 변경
    const onChangeCompanyCode = (value) => {
        setCompanyCode(value);
    };

    // 자산유형 변경
    const onChangeAssetType = (value, option) => {
        setAssetType(value);
        setAssetTypeName(option.children[2]);
    };

    // InputText 입력값 변경
    const onChangeInputHandler = (event) => {
        if (event.target.id == "reportName") {
            setReportName(event.target.value);
        } 
    };

    // 검색 클릭 시
    const onClickSearchHandler = () => {
        // 회사 필수조건 체크
        if (companyCode == '') {
            Modal.info({title: "회사는 필수 조회조건입니다."});
            return;
        }

        // 취약점분석 조회
        findTemplateList();

    };

    // 취약점분석 조회 API
    const findTemplateList = () => {
        // 회사코드가 없으면 조회하지 않음
        if (!companyCode) return;
        
        setIsLoading(true);
        setIsDataChange(false);
        axios.get(getFindAnalysisList(companyCode,assetType,reportName,'',''))
            .then((response) => {
                // console.dir(response.data);
                setIsLoading(false);
                setDataSource(response.data);
                if(response.data.totalCount == 0) {
                    Modal.info({title: "No Data.", okText:"Close"});
                }
            })
            .catch((error) => {
                setIsLoading(false);
            });
    };

    // 취약점분석 등록 클릭 시
    const onClickCreateHandler = () => {
        
        const _width = '900';
        const _height = '400';
        const _left = Math.ceil(( window.screen.width - _width )/2);
        const _top = Math.ceil(( window.screen.height - _height )/2); 
        
        setIsDataChange(false);
        //window.open('#/template/create', 'analysisCreate', 'width='+ _width +', height='+ _height +', left=' + _left + ', top='+ _top + 'scrollbars=no');
        setIsOpen(true);
    }
    
    // 화면로딩시 자동조회
    useEffect(() => {
        if (companyCode != '') {
            findTemplateList();
        }
    }, []);

    // 정보 변경시 재조회
    useEffect(() => {
        // 취약점분석 조회
        if(isDataChange && companyCode != '') {
            findTemplateList();
        }
    }, [isDataChange]);

    /** -------------------------------------------------------------------------- **/
    function onClickDetailHandler(value) {
        
        if (value.columnType == 'info') {

            var _width = '1200';
            var _height = '800';
            const option = getPopupSizeOption(_width, _height);

            const url = '#/template/info/'+value.report_id;
            const target = 'templateInfo';
            //window.open(url, target, option);
            setIsOpenInfo(true);
            setIsReportId(value.report_id);
        }

    };


    // 템플릿_목록
    const templateColumnData = [
        {
            title: '자산구분',
            dataIndex: 'asset_type',
            key: 'asset_type',
            width: '140px',
            align: 'center',
            fixed: true,
            sorter: {
                compare: (a, b) => a.asset_type.localeCompare(b.asset_type),
            },
            render: (_ , rowData ) => {
                return (
                    getCodeName('asset_type', rowData.asset_type)
                );
            },
        },
        {
            title: '템플릿ID',
            dataIndex: 'report_id',
            key: 'report_id',
            width: '200px',
            align: 'center',
            fixed: true,
            sorter: {
                compare: (a, b) => a.report_id.slice(-8).localeCompare(b.report_id.slice(-8)),
            },
        },
        {
            title: '템플릿명',
            dataIndex: 'report_nm',
            key: 'report_nm',
            width: '230px',
            align: 'left',
            fixed: true,
            ellipsis : true,
            render: (_ , rowData ) => {
                return (
                    <Typography.Link onClick={() => onClickDetailHandler({columnType: 'info', report_id: rowData.report_id})}>
                        {rowData.report_nm}
                    </Typography.Link>
                );
            },
            sorter: {
                compare: (a, b) => a.report_nm.localeCompare(b.report_nm),
            },
        },
        {
            title: '설명',
            dataIndex: 'report_desc',
            key: 'report_desc',
            width: '400px',
            align: 'left',
            fixed: true,
            ellipsis : true,
            sorter: {
                compare: (a, b) => a.report_nm.localeCompare(b.report_nm),
            },
        },
    ];

    /** -------------------------------------------------------------------------- **/
    return (
        <>
            <TopMenu selectKey='template' />
            <div className="section">
                <table className='search'>
                    <colgroup>
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                        <col style={{width:'7%'}} />
                        <col style={{width:'18%'}} />
                    </colgroup>
                    <tbody>
                    <tr>
                        <th><span className='req'>*</span>구분</th>
                        <td>
                            <Select id="companyCode"
                                    size="small"
                                    style={{width: "80%"}}
                                    value={companyCode}
                                    onChange={onChangeCompanyCode}
                                    disabled={true}
                            >
                                <Option key={0} value={'TMPL'}>{'템플릿'}</Option>
                            </Select>
                        </td>
                        <th>자산구분</th>
                        <td>
                            <CodeSelect codeType="asset_type"
                                        id="assetType"
                                        value={assetType}
                                        disabled={false}
                                        onChangeHandler={onChangeAssetType}
                            />
                        </td>
                        <th>템플릿명</th>
                        <td>
                            <Input id="reportName" size="small"
                                   allowClear
                                   value={reportName}
                                   onChange={onChangeInputHandler}
                                   onPressEnter={onClickSearchHandler}
                            />
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div className="search_button">
                    <Button type="default" onClick={onClickSearchHandler}>조회</Button>
                    <Button type="primary" onClick={onClickCreateHandler}>템플릿 등록</Button>
                </div>
            </div>
            <div className="section">
                <table style={{width:'100%'}}><tbody>
                  <tr>
                    <td><div style={{marginLeft:'20px'}}>총 {dataSource?.length} 개</div></td>
                    <td style={{textAlign:'right'}}>
                        <Button type="default" onClick={()=> excelDownload('템플릿 목록', dataSource)}> Excel Download</Button>
                    </td>
                  </tr></tbody>
                </table>
                <Table columns={templateColumnData}
                       dataSource={dataSource}
                       rowKey="report_id"
                       scroll={{y: getGridTableHeight(280)}}
                       loading={{
                           size: "large",
                           spinning: isLoading
                         }}
                       pagination={false}
                       bordered size={"small"}
                       style={{height:getGridTableHeight(250)}}
                       showSorterTooltip={false}
                />
            </div>
            {isOpen && (<TemplateCreate
                open={isOpen}
                rowKey="report_id"
                p_companyCode={companyCode}
                p_assetType={assetType}
                p_assetTypeName={assetTypeName}
                onClose={(p_isChange) => {
                    setIsOpen(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
            {isOpenInfo && (<TemplateInfo
                open={isOpenInfo}
                rowKey="report_id"
                p_reportId={isReportId}
                onClose={(p_isChange) => {
                    setIsOpenInfo(false);
                    setIsDataChange(p_isChange);
                }}
            />)}
        </>

    );
}
export default TemplateList;